import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { KmxContainer } from '../../../../components/KmxContainer';

interface HeadingContainerProps {
    children: ReactNode[];
}

const HeadingContainer = ({ children }: HeadingContainerProps) => (
    <KmxContainer
        className="buying-online-hero--container"
        maxWidth="xl"
        sx={{
            pt: { xs: 2, sm: 8 },
        }}
    >
        <Box
            className="buying-online-hero"
            sx={{
                minHeight: { lg: '55.625rem' },
                maxHeight: { lg: '55.625rem' },
                position: 'relative',
                pb: { xs: 4, sm: 15 },
                clipPath: 'rect(-200% 100% 100% -200%)',
                '&:after': {
                    // draws the box that produces the scroll-fadeout effect
                    content: '""',
                    width: '100%',
                    height: '35vh',
                    position: 'absolute',
                    bottom: -1,
                    background: `linear-gradient(to bottom,
                        rgba(255, 255, 255, 0) 0%,
                        rgba(255, 255, 255, 0.99) 72%,
                        rgba(255, 255, 255, 1) 73%,
                        rgba(255, 255, 255, 1) 100%)`,
                },
            }}
        >
            <Stack direction={{ xs: 'column', lg: 'row' }}>{children}</Stack>
        </Box>
    </KmxContainer>
);

export default HeadingContainer;
